import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Icon from 'presentation/icons';
import {AppleStore, GooglePlay} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useHostName} from 'presentation/hooks/useHostName';
import {AppStoreCard, AppStoreTitle, StyledLink} from './styles';

const {downloadApp} = translations['pt-br'].publicFlow;

export function AppStore() {
	const {dataHostNameState} = useHostName();
	const {androidStoreLink, iosStoreLink, product} = dataHostNameState;

	return (
		<AppStoreCard>
			<AppStoreTitle>
				<Icon name="download" />
				<Typography fontWeight={700}>{downloadApp[product]}</Typography>
			</AppStoreTitle>
			<Stack direction="row" gap={2} justifyContent="center">
				<StyledLink href={iosStoreLink} target="_blank" rel="noopener noreferrer">
					<AppleStore />
				</StyledLink>
				<StyledLink href={androidStoreLink} target="_blank" rel="noopener noreferrer">
					<GooglePlay />
				</StyledLink>
			</Stack>
		</AppStoreCard>
	);
}
